import {
  multiLineString,
  point,
  featureCollection
} from '@turf/helpers';

import step1Geom from '../../data/ve-polygon.json';

function getGeometry(id) {
  // Every point that needs to be placed
  let col = [-73.2252107507406, 2.487868459447];
  let ve = [-65.85500742189559, 6.997995004753577];

  let cur = [-68.933333, 12.116667];
  let mia = [-80.271764, 25.795502];
  let aw = [-70.035833, 12.518611];
  let curAw = [-69.46166460836476, 12.323676996433448];

  // Random points in the US
  let us1 = [-76.57263101496613, 40.83051812910696];
  let us2 = [-91.28432763971682, 42.889251891433105];
  let us3 = [-110.61374856271745, 44.82627737784176];
  let us4 = [-122.79506403058419, 39.406317861144515];

  let geom;
  let line;
  let lineArray;

  // step determines geom that is built
  switch (id) {
    case 'step2':
      line = multiLineString([[ve, col], [ve, cur], [ve, aw]]);
      geom = featureCollection([
        line,
        point(col),
        point(ve),
        point(cur, { name: 'Curaçao' }),
        point(aw, {name: 'Aruba'})
      ]);
      break;
    case 'step3':
      line = multiLineString([[col, mia], [curAw, mia]]);
      geom = featureCollection([
        line,
        point(mia, { name: 'Miami' }),
        point(col),
        point(curAw, { name: 'Curaçao & Aruba' })
      ]);
      break;
    case 'step4':
      line = multiLineString([[mia, us1], [mia, us2], [mia, us3], [mia, us4]]);
      geom = featureCollection([line, point(mia, { name: 'Miami' })]);
      break;
    case 'step5':
      lineArray = [[mia, curAw], [mia, col], [col, ve], [curAw, ve]];
      line = multiLineString(lineArray);
      geom = featureCollection([
        line,
        point(mia, { name: 'Miami' }),
        point(curAw, { name: 'Curaçao & Aruba' }),
        point(col),
        point(ve)
      ]);
      break;
    default:
      geom = null;
  }

  return geom;
}

const geom = {
  step1: step1Geom,
  step2: getGeometry('step2'),
  step3: getGeometry('step3'),
  step4: getGeometry('step4'),
  step5: getGeometry('step5')
};

export { geom };
